module.exports = {
    status: 'development',
    baseUrl: "https://hamrahi.cloud",
    driveRestAPI: "https://hamrahi.cloud/api",
    chatBaseUrl: "wss://hamrahi.cloud/",
    GA_MEASUREMENT_ID: "G-5JZ2S6WR6D",
    favIconUrl: "https://hamrahi.cloud/drive/hamrahi.svg",
    zarebinUserConfig: "https://hamrahi.cloud/get-header",
    loginBaseUrl: 'https://landing-restapi.pr.mci.dev',
    trackerRestAPI: 'https://hamrahi.cloud',
    aggregatorBaseUrl: 'https://aggregator.hamrahi.cloud/',
    setAggregatorBaseUrl: 'https://setaggregator.hamrahi.cloud/',
    fluentdUrl: 'https://hamrahi.cloud',
    loginRedirectUrl: 'zarebinlite://login',
    cookieKey: 'HAMRAHI_CLOUD_AUTH_TOKEN',
    whiteListTargets: 'abrehamrahi.ir,hamrahi.cloud,sthamrahi.ir',
    whiteListGeneralUrl: 'hamrahi.cloud,abrehamrahi.ir,zarebin.ir,mohtava.cloud,eshterak.cloud,cinemahamrah.ir',
    sendXToken: 'true',
    voucherAPI: 'https://cinemahamrah.ir',
    chatAPIBaseUrl: 'https://hamrahi.cloud/chatapi/',
    ekran: 'https://ekrn.ir',
    cinemaHamrah: 'false',
    assistant: false,
    initialLoadedFragmentCount: "3",
    filmAndSerialAllowedUsers : JSON.stringify([
        {
            user_id: 216,
        },
        {
            user_id: 196,
        },
    ]),
    cinemaHamrahAllowedUsers: JSON.stringify([
        {
            user_id: 43873,
            free: true
        }
    ]),
    keshtAllowedUsers : JSON.stringify([
        {
            user_id: 98735,
        },
    ]),
    filmAndSerialBasePath: "/film-serial"
}
